import React, { FC } from 'react';
import { useFullBook } from '../../hooks';
import { IBook } from '../../../../config/api/models/Book';
import { TreeItem } from '@material-ui/lab';
import { TrajectoryTreeViewItem } from './index';
import { useParams } from 'react-router';
import { UrlParams } from '../../types';
import { Theme, styled } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

type TrajectoryTreeViewBookProps = {
  book: IBook;
  onSelected: (chapterId: string, fromBook: string, toBook: string) => void;
  selectedChapter: string;
};

const StyledTreeItem = styled(TreeItem)<Theme>(({ theme }) => ({
  padding: '0.5rem 0',
  borderBottom: `1px solid ${theme.palette.grey['100']}`,
  '& .MuiTreeItem-root': {
    padding: '0.5rem 0',
  },
  '&.Mui-selected .MuiTreeItem-label, .Mui-selected .MuiTreeItem-label': {
    background: 'transparent !important',
  },
  '& .MuiTreeItem-label:hover': {
    background: `${theme.palette.grey['50']} !important`,
  },
}));

const TrajectoryTreeViewBook: FC<TrajectoryTreeViewBookProps> = ({
  book,
  onSelected,
  selectedChapter,
}) => {
  const fullBook = useFullBook(book.id);
  const { bookId } = useParams<UrlParams>();
  const { t } = useTranslation();

  const handleSelected = (chapterId: string) => {
    if (!bookId) return;
    onSelected(chapterId, bookId, book.id);
  };

  return book.chapterDepth > 0 ? (
    <StyledTreeItem nodeId={book.id} label={`${book.title} ${fullBook.pending ? t('shared.loading') : ''}`}>
      {fullBook.data?.chapters.map((chapter, index) => (
        <TrajectoryTreeViewItem
          key={index}
          data={chapter}
          depth={2}
          maxDepth={book.chapterDepth}
          onSelected={handleSelected}
          selectedChapter={selectedChapter}
        />
      ))}
    </StyledTreeItem>
  ) : (
    <TreeItem nodeId={book.id} label={book.title} />
  );
};

export default TrajectoryTreeViewBook;
